import { Tool } from './tool';

/** Verwaltet das aktive Werkzeug, Cursor und Statusleiste. */
export class ToolManager {
  private tools = new Map<string, Tool>();
  private _active: Tool | null = null;
  private listeners = new Set<(tool: Tool) => void>();

  constructor(private canvas: HTMLCanvasElement) {}

  register(tool: Tool): void {
    this.tools.set(tool.id, tool);
  }

  get active(): Tool | null {
    return this._active;
  }

  get(id: string): Tool | undefined {
    return this.tools.get(id);
  }

  switchTo(id: string): void {
    const next = this.tools.get(id);
    if (!next || next === this._active) return;
    this._active?.exit();
    this._active = next;
    next.enter();
    this.canvas.style.cursor = next.cursor;
    for (const fn of this.listeners) fn(next);
  }

  onSwitch(fn: (tool: Tool) => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
}
